
interface CookieTypeCardProps {
  title: string;
  titleColor: string;
  bgColor: string;
  description: string;
  duration: string;
}

const CookieTypeCard = ({ title, titleColor, bgColor, description, duration }: CookieTypeCardProps) => {
  return (
    <div className={`${bgColor} p-4 rounded-lg`}>
      <h3 className={`text-lg font-semibold ${titleColor} mb-3`}>{title}</h3>
      <p className="text-gray-700 text-sm">
        {description}
      </p>
      <p className="text-gray-700 text-sm mt-2">
        <strong>Duration:</strong> {duration}
      </p>
    </div>
  );
};

export default CookieTypeCard;
